import React from 'react';

import { Button, TitleWithDescription } from '@infoods/lifebase-ui';

import classes from './ChallengeBlock.module.scss';
import { goTo } from '../../../../../shared/utils/angularUtils';
import { useChallengeBanner } from './hooks/useChallengeBanner';

type ChallengeBlockProps = {
  challengeId: number;
};

const ChallengeBlock = ({ challengeId }: ChallengeBlockProps) => {
  const { challengeBannerUrl } = useChallengeBanner({ challengeId });

  const handleRegisterForChallengeClick = () => {
    goTo(`/challenge-landing/${challengeId}`);
  };

  return (
    <div className={classes.container}>
      <TitleWithDescription
        title="2. Register For The Challenge"
        titleFont="title-18-bold"
        description="You may now purchase your challenge ticket"
      />
      {challengeBannerUrl && (
        <img
          className={classes.challengeImage}
          src={challengeBannerUrl}
          alt="Challenge banner"
        />
      )}
      <Button
        variant="contained"
        color="primary"
        size="medium"
        className={classes.button}
        onClick={handleRegisterForChallengeClick}
      >
        Register for Challenge
      </Button>
    </div>
  );
};

export { ChallengeBlock };
